/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from '@reach/router';
import { MdKeyboardArrowRight } from '@react-icons/all-files/md/MdKeyboardArrowRight';
import { AiOutlineInfoCircle } from '@react-icons/all-files/ai/AiOutlineInfoCircle';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Button, Grid } from '@material-ui/core';
import Skeleton from 'react-loading-skeleton';
import DialogContent from '@material-ui/core/DialogContent';
import DrawerPwa from '../../../components/DrawerPwa';
import DialogBox from '../../../components/DialogBox';
const { selectDesktop } = Slices.appSlice;
const { selectCurrentCurrency } = Slices.configSlice;
const { cartAppliedPromos, selectCartStatus, selectOfferAmount, cartAmount } = Slices.cartSlice;
const { couponCodeApplied, offerApplied } = Slices.offerSlice;
import ClassNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import couponIco from '../images/coupon.svg';
import appliedCoupon from '../images/appliedCoupon.svg';
import errorCoupon from '../images/errorCoupon.svg';

import css from './index.module.scss';

// TODO: Validate all coupon logic with Farhan and app team
export default function CouponBox({ onRemove, refreshCart, selectFreeItem }) {
  const navigate = useNavigate();
  const location = useLocation();
  const intl = useIntl();

  const isDesktop = useSelector(selectDesktop);
  const currency = useSelector(selectCurrentCurrency);
  const cart = useSelector((state) => state.cart);
  const cartStatus = useSelector(selectCartStatus);
  const cartAmountList = useSelector(cartAmount);
  const cartPromo = useSelector(cartAppliedPromos);
  let couponApplied = cartPromo?.couponCode || '';
  let couponSelected = useSelector(couponCodeApplied);
  const offerSelected = useSelector(offerApplied);
  const offers = useSelector((state) => state.offer);

  const couponAmount = useSelector((state) => selectOfferAmount(state, couponApplied));

  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [status, setStatus] = useState('loading');
  const [icon, setIcon] = useState('');
  const [heading, setHeading] = useState('');
  const [subHeading, setSubHeading] = useState('');
  const [className, setClassName] = useState(css.loading);

  const lang = intl.locale.split('-')[0];

  const findOfferWithCouponCode = React.useCallback((couponCode) => {
    return offers.data?.info?.list?.find((offer) => offer.couponCode == couponCode);
  });
  const discount = cartAmountList.find((each) => each.type === 'DISCOUNT');
  const subTotal = cartAmountList.find((each) => each.type === 'SUB_TOTAL');

  const notApplied = () => {
    setStatus('error');
    setClassName(css.errorCoupon);
    setIcon(errorCoupon);
    setHeading(
      intl.formatMessage({
        id: 'cart_couponnotapplied',
        defaultMessage: 'Offer Not Applied',
      })
    );
    setSubHeading(
      intl.formatMessage(
        {
          id: 'CouponBox_offerNotApplied',
          defaultMessage: 'Offer {offer} not applied on this order',
        },
        {
          offer:
            findOfferWithCouponCode(couponSelected) &&
            findOfferWithCouponCode(couponSelected).couponHidden == 1
              ? ''
              : couponSelected,
        }
      )
    );
  };
  useEffect(() => {
    if (cartStatus === 'succeeded') {
      const discountedItems = cart.data.items.filter((element) => element?.isDiscounted);

      if (couponApplied && subTotal && discountedItems.length > 0) {
        let subTotalAmount = subTotal?.amount;
        discountedItems.forEach((item) => {
          subTotalAmount -= item.finalPrice;
        });
        let minOfferAmount = cartPromo?.minCartAmt || 0;

        if (subTotalAmount < minOfferAmount) {
          console.log(`9) refreshCart`);
          refreshCart(false, false, true);
          couponApplied = '';
        }
      }
      if (couponApplied) {
        if (cart.data.couponApplied === 0 && !selectFreeItem) {
          notApplied();
        } else {
          setStatus('applied');
          setClassName(css.appliedCoupon);
          setIcon(appliedCoupon);
          setHeading(
            intl.formatMessage({ id: 'cart_couponapplied', defaultMessage: 'Offer Applied' })
          );
          if (findOfferWithCouponCode(couponSelected)?.couponHidden == 1) {
            setSubHeading(
              intl.formatMessage(
                { id: 'CouponBox_offer_hidden', defaultMessage: '{offer}' },
                { offer: findOfferWithCouponCode(couponSelected)?.ruleName }
              )
            );
          } else if (cartPromo.couponType === 'freeitem') {
            setSubHeading(
              intl.formatMessage(
                { id: 'CouponBox_offer_freeitem', defaultMessage: 'Offer {offer} applied.' },
                { offer: couponApplied }
              )
            );
          } else {
            setSubHeading(
              intl.formatMessage(
                {
                  id: 'CouponBox_offer',
                  defaultMessage: 'Offer {offer} applied. You saved {amount}',
                },
                { offer: couponApplied, amount: `${couponAmount} ${currency}` }
              )
            );
          }
        }
      } else if (couponSelected && !selectFreeItem) {
        notApplied();
      } else {
        setStatus('none');
        setClassName(css.noCoupon);
        setIcon(couponIco);
        setHeading(intl.formatMessage({ id: 'cart_applycoupon', defaultMessage: 'Apply Coupon' }));
      }
    } else {
      setStatus('loading');
      setClassName(css.loading);
      setIcon('');
      setHeading('');
      setSubHeading('');
    }
  }, [
    cartPromo.couponType,
    cartStatus,
    couponAmount,
    couponApplied,
    couponSelected,
    currency,
    findOfferWithCouponCode,
    intl,
  ]);

  const handleLink = () => {
    if (status === 'none') {
      navigate(`/${intl.locale}/offers/cart`, {
        state: {
          oldLocation: JSON.parse(JSON.stringify(location)),
          mode: 'right',
          // description: intl.formatMessage({ id: 'navigation_offers' }),
          // titleId: 'navigation_offers',
        },
      });
    }
  };

  const getSubHeading = () => {
    return status === 'applied' || status === 'error' ? (
      <p className={css.subHeading}>{subHeading}</p>
    ) : (
      <p className={css.subHeading}>
        <FormattedMessage
          id={'default_apply_coupon_message'}
          defaultMessage={'Apply coupon & view great offers available'}
        />
      </p>
    );
  };

  const getButtons = () => {
    if (status === 'loading') return '';
    return status === 'applied' || status === 'error' ? (
      <React.Fragment>
        <Button className={css.remove} onClick={onRemove}>
          <FormattedMessage id="cart_remove" defaultMessage="Remove" />
        </Button>
        <Button className={css.buttonViewTC} onClick={() => setIsTermsOpen(!isTermsOpen)}>
          <AiOutlineInfoCircle className={css.infoIcon} />
          <FormattedMessage id="cart_viewTC" defaultMessage="View T&C" />
        </Button>
      </React.Fragment>
    ) : (
      <MdKeyboardArrowRight className={css.rightIcon} />
    );
  };

  const getRuleName = () => {
    const baseObj = status === 'applied' ? cartPromo : offerSelected;
    if (!baseObj) return '';

    return baseObj[`ruleName_${lang}`] || '';
  };

  const getTncHTML = () => {
    const baseObj = status === 'applied' ? cartPromo : offerSelected;
    if (!baseObj) return '';

    const tnc = baseObj[`tnc_${lang}`] || '';
    var parser = new DOMParser();
    var doc = parser.parseFromString(tnc, 'text/html');
    return doc.getElementsByTagName('body')[0].innerHTML;
  };

  return (
    <div className={ClassNames(css.root, className)} onClick={handleLink}>
      {cartStatus === 'loading' ? (
        <Skeleton count="1" height="3rem" />
      ) : (
        <React.Fragment>
          <div className={css.iconRight}>
            {icon && (
              <div className={css.icon}>
                <img src={icon} alt="Coupon Icon" width="22" height="22" />
              </div>
            )}
          </div>
          <div className={css.couponHeading}>
            <h4 className={css.heading}>{heading}</h4>
            {getSubHeading()}
          </div>
          <div className={css.iconRight}>{getButtons()}</div>
        </React.Fragment>
      )}

      {!isDesktop ? (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={isTermsOpen}
          className={css.drawer}
          onClose={() => setIsTermsOpen(false)}
        >
          <div className={css.inner}>
            <div className={css.badge}>
              {findOfferWithCouponCode(couponSelected) &&
              findOfferWithCouponCode(couponSelected).couponHidden == 1 ? (
                ''
              ) : (
                <div className={css.couponCode}>
                  <FormattedMessage id="promo_code" defaultMessage="PROMO CODE" />: {couponSelected}
                </div>
              )}
              {getRuleName()}
            </div>
            <Grid className={css.termsContainer}>
              <div dangerouslySetInnerHTML={{ __html: getTncHTML() }}></div>
            </Grid>
          </div>
        </DrawerPwa>
      ) : (
        <>
          <DialogBox
            title=""
            size="sm"
            isOpen={isTermsOpen}
            onClose={() => setIsTermsOpen(false)}
            page="login"
          >
            <DialogContent dividers={true}>
              <div className={css.inner}>
                <div className={css.badge}>
                  {findOfferWithCouponCode(couponSelected) &&
                  findOfferWithCouponCode(couponSelected).couponHidden == 1 ? (
                    ''
                  ) : (
                    <div className={css.couponCode}>
                      <FormattedMessage id="promo_code" defaultMessage="PROMO CODE" />:
                      {couponSelected}
                    </div>
                  )}
                  {getRuleName()}
                </div>
                <Grid className={css.termsContainer}>
                  <div dangerouslySetInnerHTML={{ __html: getTncHTML() }}></div>
                </Grid>
              </div>
            </DialogContent>
          </DialogBox>
        </>
      )}
    </div>
  );
}
